import { isIe11 } from 'Utils/browserDetect'; //eslint-disable-line
const styleSheet = (theme: any) => ({
  formWrapper: {
    ...theme.formWrapper,
    opacity: 0,
    display: isIe11() ? 'table-cell' : 'block',
    verticalAlign: isIe11() ? 'middle' : 'inherit',
  },
  stepImage: {
    height: '224px',
    marginBottom: '30px',
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },
  centerForm: {
    display: isIe11() ? 'table' : 'flex',
    width: '100%',
    minHeight: '100vh',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: isIe11() ? '820px' : 'inherit',
    margin: isIe11() ? '0 auto' : 'inherit',
  },
  stepAnim: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    alignContent: 'center',
    alignSelf: 'center',
  },
  footerText: {
    boxSizing: 'border-box',
    fontFamily: 'CircularStd, sans-serif',
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 1.75,
    color: '#6373a4',
    bottom: '5px',
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    '@media (max-width: 900px)': {
      position: 'relative',
      bottom: '0',
    },
    '& > a': {
      fontWeight: 'bold',
      textDecoration: 'none',
      color: '#6373a4',
    },
  },
  progressBarCenter: {
    width: '100%',
    backgroundColor: '#fff',
    height: '25px',
    paddingTop: '30px',
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1000,
    '@media (max-width: 900px)': {
      paddingTop: '22px',
    },
  },
  progressBarHolder: {
    // marginTop: "60px",
    // marginBottom: "60px",
    // "@media (max-width: 900px)": {
    //   marginTop: "-33px"
    // }
  },
  poweredByContainer: {
    position: 'fixed',
    right: '20px',
    fontFamily: 'CircularStd, sans-serif',
    bottom: '10px',
    fontSize: '10px',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#6373a4',
    '@media (max-width: 900px)': {
      position: 'relative',
      width: '100%',
      textAlign: 'center',
      marginTop: '20px',
      right: 0,
      bottom: '0',
    },
  },
  poweredByContainerFirstStep: {
    '@media (max-width: 900px)': {
      marginTop: '0 !important',
      bottom: '20px !important',
    },
  },
  youvisitText: {
    fontSize: '14px',
  },
  gdprErrorTextContainer: {
    display: 'flex',
    fontSize: '12px',
    width: '250px',
    height: '15px',
    fontFamily: 'CircularStd, sans-serif',
    fontWeight: '500',
    color: '#d0021b',
    marginLeft: '3%',
    paddingBottom: '2%',
  },
  centerForIE: {
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  visitorsMaxWidth: {
    maxWidth: '855px',
  },
  closeButton: {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'fixed',
    right: '20px',
    top: '20px',
    background: 'transparent',
    border: 0,
    margin: '10px',
    zIndex: 10000,
  },
  backButton: {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'fixed',
    left: '20px',
    top: '20px',
    background: 'transparent',
    border: 0,
    margin: '10px',
    zIndex: 9999,
    transform: 'rotate(91deg) scale(1.2)',
  },
  appilyLogo: {
    width: '68px',
    margin: '-5px 5px',
    display: 'inline-block',
  },
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/step/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/components/step/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }